export default (state = { id: null, mProps: {} }, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_MODAL': {
      return { id: action.modalId, mProps: action.props };
    }
    default:
      return state;
  }
};
